import { render, staticRenderFns } from "./ImportProcesses.vue?vue&type=template&id=285eff4d&"
import script from "./ImportProcesses.vue?vue&type=script&lang=js&"
export * from "./ImportProcesses.vue?vue&type=script&lang=js&"
import style0 from "./ImportProcesses.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports